import { SvgIcon } from "@mui/material";

const Plant = (props) => {
  return (
    <SvgIcon viewBox="0 0 14 12" {...props}>
      {/* Main stem */}
      <path d="M7 11.5C6.77614 11.5 6.5 11.2761 6.5 11V6C6.5 5.72386 6.72386 5.5 7 5.5C7.27614 5.5 7.5 5.72386 7.5 6V11C7.5 11.2761 7.22386 11.5 7 11.5Z" />
      
      {/* Left leaf */}
      <path
        d="M2 5C2.5 3 5 2 6.5 3.5C6 5.5 3.5 6 2 5Z"
      />
      
      {/* Right leaf */}
      <path
        d="M12 5C11.5 3 9 2 7.5 3.5C8 5.5 10.5 6 12 5Z"
      />

      {/* Base / soil (secondary path) */}
      <path
        className="secondary"
        d="M1 10.8C1 10.64 1.14 10.5 1.3 10.5H12.7C12.86 10.5 13 10.64 13 10.8V11.2C13 11.36 12.86 11.5 12.7 11.5H1.3C1.14 11.5 1 11.36 1 11.2V10.8Z"
      />
    </SvgIcon>
  );
};

export default Plant;
